﻿<template>
    <div class="flex flex-column w-full" v-if="ready">
        <FavLinks align="center" />
        <div class="flex">
            <RouterView />
        </div>
    </div>
    <SignalR ref="signalR"> </SignalR>
</template>


<script lang="ts">
    export default {
        name: module$.main,
        inheritAttrs: false
    }
</script>

<script setup lang="ts">
    import { onMounted, onUnmounted, ref } from 'vue'
    import { module$ } from '../enums'
    import { utilfcty$, utility, signalrEvent$, signalrCallback } from '../utils/utility'
    import SignalR from '../components/SignalR.vue'

    defineProps<{
    }>()

    // ***************工具物件***************
    //util$物件
    const util$ = utilfcty$.vueUse();
    //SignalR
    const signalR = ref();

    // ***************元件屬性|計算**********
    const ready = ref(false);

    // ***************函式/事件**************
    const onSignalrConnected: signalrCallback = () => {
        ready.value = true;
    }
    // ***************元件監看***************

    // ***************元件鉤子***************
    onMounted(() => {
        //註冊message事件
        utility.signalR$.on(signalrEvent$.connected, onSignalrConnected);
    })

    onUnmounted(() => {
        utility.signalR$.off(signalrEvent$.connected, onSignalrConnected);
    })

</script>


<style scoped>
</style>
